import { Link } from "react-router-dom";
/* Commenting the following code for logo.ray using AI Agent. 18/08/2026. Comment Start */
// import Logo from "../images/Logo.png";
/* Commenting end. ray using AI Agent. 18/08/2026 */
/* Added the following code for logo.ray using AI Agent. 18/08/2026. Code Start */
/* Navy/blue logo for this light footer; white Logo.png stays on dark chrome. */
/* Commenting the following code for logo.ray using AI Agent. 24/08/2026. Comment Start */
// import Logo from "../images/Logo-dark.svg";
/* Commenting end. ray using AI Agent. 24/08/2026 */
/* Added the following code for logo.ray using AI Agent. 24/08/2026. Code Start */
import Logo from "../images/Logo-dark.png";
/* Code end. ray using AI Agent. 24/08/2026 */
/* Code end. ray using AI Agent. 18/08/2026 */

const Footer = () => {
  return (
    <div className="mt-24 bg-gray-50">
  <div className="border-t border-gray-300 py-8 px-6 md:px-12">
    <div className="flex flex-col md:flex-row justify-between items-center gap-8">
      {/* Logo */}
      {/* Added the following code for logo.ray using AI Agent. 24/08/2026. Code Start */}
      <div className="inline-flex flex-shrink-0 flex-col items-stretch">
        {/* Commenting the following code for logo.ray using AI Agent. 24/08/2026. Comment Start */}
        {/* <img src={Logo} alt="Logo" className="w-36 md:w-44" /> */}
        {/* <img src={Logo} alt="Logo" className="block h-auto w-44 object-contain md:w-52" /> */}
        {/* Commenting end. ray using AI Agent. 24/08/2026 */}
        {/* Added the following code for logo.ray using AI Agent. 24/08/2026. Code Start */}
        <img src={Logo} alt="Logo" className="block h-auto w-0 min-w-full object-contain" />
        <p className="mt-1 whitespace-nowrap text-sm tracking-wide text-[#044661]">
          From Learning AI to Building AI
        </p>
        {/* Code end. ray using AI Agent. 24/08/2026 */}
      </div>
      {/* Code end. ray using AI Agent. 24/08/2026 */}

      {/* Footer Links */}
      <div className="flex flex-col md:flex-row gap-4 md:gap-8 text-center md:text-left">
        <Link
          to="/"
          className="text-[#475467] hover:text-sky-700 font-medium text-sm md:text-base"
        >
          About
        </Link>
        <Link
          to="/solutions"
          className="text-[#475467] hover:text-sky-700 font-medium text-sm md:text-base"
        >
          Modules
        </Link>
        <Link
          to="/contact"
          className="text-[#475467] hover:text-sky-700 font-medium text-sm md:text-base"
        >
          Subscribe
        </Link>
        <Link
          to="/blogs"
          className="text-[#475467] hover:text-sky-700 font-medium text-sm md:text-base"
        >
          Blogs
        </Link>
      </div>
    </div>

    {/* Divider */}
    <div className="border-t border-gray-300 mt-6 pt-4 flex flex-col md:flex-row justify-between items-center text-center text-sm text-[#667085]">
      <p>© 2024 SelfTrainAI. All rights reserved.</p>

      {/* Optional Social Icons */}
      {/* <div className="flex gap-4 mt-2 md:mt-0">
        <a href="#" aria-label="Twitter" className="text-[#475467] hover:text-sky-700">
          <TwitterIcon />
        </a>
        <a href="#" aria-label="LinkedIn" className="text-[#475467] hover:text-sky-700">
          <LinkedInIcon />
        </a>
      </div> */}
    </div>
  </div>
</div>

  );
};

export default Footer;
